const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  REGISTER_WITH_EMAIL_AND_PASSWORD: 'user/REGISTER_WITH_EMAIL_AND_PASSWORD',
  FORGET_PASSWORD: 'user/FORGET_PASSWORD',
}

export default actions
